/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NoteDeleteReqVo
 */
export interface NoteDeleteReqVo {
    /**
     * 站内信ID列表
     * @type {Array<number>}
     * @memberof NoteDeleteReqVo
     */
    ids: Array<number>;
    /**
     * 接收者ID
     * @type {number}
     * @memberof NoteDeleteReqVo
     */
    receiverId: number;
}

/**
 * Check if a given object implements the NoteDeleteReqVo interface.
 */
export function instanceOfNoteDeleteReqVo(value: object): value is NoteDeleteReqVo {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('receiverId' in value) || value['receiverId'] === undefined) return false;
    return true;
}

export function NoteDeleteReqVoFromJSON(json: any): NoteDeleteReqVo {
    return NoteDeleteReqVoFromJSONTyped(json, false);
}

export function NoteDeleteReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoteDeleteReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'receiverId': json['receiverId'],
    };
}

export function NoteDeleteReqVoToJSON(json: any): NoteDeleteReqVo {
    return NoteDeleteReqVoToJSONTyped(json, false);
}

export function NoteDeleteReqVoToJSONTyped(value?: NoteDeleteReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
        'receiverId': value['receiverId'],
    };
}

